// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"183":"9f58ef0b","198":"6bc01c9f","265":"046ef708","266":"291b5e16","330":"1442435d","448":"a62e3220","536":"1559cd34","625":"672c135f","771":"a361562b"}[chunkId] + ".js";
};